// Make ApexCharts available globally for react-apexcharts
import ApexCharts from 'apexcharts';

if (typeof window !== 'undefined') {
  window.ApexCharts = ApexCharts;
}

